// extracted by mini-css-extract-plugin
export default {"logoSvg":"EgoLogo_logoSvg__gs-dL"};